if (!customElements.get('amelie-fixed-sets')) customElements.define('amelie-fixed-sets',class extends HTMLElement{
async connectedCallback(){
if(this.ready)return;this.ready=true;
const cfg=JSON.parse(this.querySelector('[data-set-config]').textContent);
this.original=cfg.original;this.gift=cfg.gift?.variants?.find(v=>v.available);this.selected='2 Kleider';this.busy=false;
this.status=this.querySelector('[role="alert"]');this.button=this.querySelector('[data-set-add]');
this.radios=[...this.querySelectorAll('[name="amelie-set"]')];this.radios.forEach((r,i)=>r.checked=i===0);this.states=[];this.cfg={colorOption:'',unavailable:'Diese Variante ist nicht verfügbar.'};
for(const radio of this.radios){const state={radio,rows:[],details:radio.closest('.cb-card').querySelector('.cb-details')};for(let i=0;i<(radio.value==='4 Kleider'?4:2);i++){const entry={product:this.original,gift:false};
          const p = entry.product;
          const row = this.el('div','cb-row');
          const heading = this.el('div','cb-row-heading');
          const img = this.el('img'); img.width=42; img.height=52; img.alt=p.title; img.loading='lazy'; img.hidden=true;
          const title = '#' + (i+1);
          heading.append(this.el('span','',title)); row.append(heading);
          const rowState = {product:p,gift:entry.gift,selects:[],image:img,variant:p.variants.find(v=>v.available)};
          const controls = this.el('div','cb-controls');
          p.options.forEach((option,j) => {
            if (p.variants.length === 1 && p.variants[0].title === 'Default Title') return;
            const name=typeof option === 'string' ? option : option.name;
            const field = this.el('div','cb-field');
            const isColor = this.cfg.colorOption ? name.toLowerCase()===this.cfg.colorOption.toLowerCase() : /color|colour|farbe|kleur|cor$/i.test(name);
            const caption=this.el('span','cb-caption',name);field.append(caption);
            const select = this.el('select');
            select.setAttribute('aria-label',title+' — '+name);
            [...new Set(p.variants.map(v=>v.options[j]))].forEach(value => {
              const opt=this.el('option','',value);opt.value=value;select.append(opt);
            });
            select.value=rowState.variant?.options[j] || p.variants[0].options[j];
            select.addEventListener('change',()=>this.refresh(state));
            rowState.selects.push(select);
            if(isColor){
              select.hidden=true;
              const menu=this.el('details','cb-color');
              const summary=this.el('summary','cb-color-current');
              summary.setAttribute('aria-label',title+' — '+name);
              const currentText=this.el('span');
              summary.append(img,currentText,this.el('span','cb-chevron','⌄'));
              const options=this.el('div','cb-color-options');
              [...new Set(p.variants.map(v=>v.options[j]))].forEach(value=>{
                const choice=this.el('button','cb-color-option');choice.type='button';choice.setAttribute('aria-label',name+': '+value);
                const picture=this.el('img');picture.width=38;picture.height=46;picture.alt='';picture.loading='lazy';
                const v=p.variants.find(v=>v.options[j]===value && v.featured_image) || p.variants.find(v=>v.options[j]===value);
                const src=v?.featured_image?.src || p.featured_image;
                if(src)picture.src=src;else picture.hidden=true;
                choice.append(picture,this.el('span','',value));
                choice.addEventListener('click',()=>{select.value=value;menu.open=false;this.refresh(state);summary.focus();});
                options.append(choice);
              });
              menu.append(summary,options);
              menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;summary.focus();}});
              rowState.color={text:currentText,select,menu,options};
              field.append(menu);
            }
            field.append(select);controls.append(field);
          });
          row.append(controls);
          rowState.error = this.el('small','cb-unavailable'); row.append(rowState.error);
          state.rows.push(rowState);

state.details.append(row);

}this.states.push(state);}
this.money=n=>new Intl.NumberFormat('de-DE',{style:'currency',currency:cfg.currency}).format(n/100);
for(const radio of this.radios)radio.addEventListener('change',()=>{this.selected=radio.value;this.status.textContent='';this.refresh();});

this.button.addEventListener('click',()=>this.add());
this.refresh();

this.refresh();
}
el(tag,cls='',text){const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;}
refresh(){
this.quantity=this.selected==='4 Kleider'?4:2;
for(const state of this.states){
state.details.hidden=!state.radio.checked;
for(const row of state.rows){
row.variant=this.original.variants.find(v=>v.options.every((value,i)=>value===row.selects[i].value));
row.error.textContent=row.variant?.available?'':this.cfg.unavailable;
if(row.color){row.color.text.textContent=row.color.select.value;[...row.color.options.children].forEach(b=>b.setAttribute('aria-pressed',String(b.textContent===row.color.select.value)));}
const src=row.variant?.featured_image?.src||this.original.variants.find(v=>v.options[0]===row.selects[0].value&&v.featured_image)?.featured_image?.src||this.original.featured_image;
if(src){row.image.src=src;row.image.hidden=false;}
}
}
this.active=this.states.find(s=>s.radio.checked);
this.valid=this.active.rows.every(row=>row.variant?.available);
for(const r of this.radios)r.closest('.cb-card').classList.toggle('is-selected',r.checked);

const unavailable=!this.valid||!this.gift;
this.button.disabled=this.busy||unavailable;
this.button.textContent=unavailable?'Derzeit nicht verfügbar':'In den Warenkorb · '+this.money(this.quantity===4?12990:6990);
}
async add(){
if(this.busy||!this.valid||!this.gift)return;
this.busy=true;this.refresh();this.button.setAttribute('aria-busy','true');this.status.textContent='Wird hinzugefügt …';
let added=false;
try{
const request=async(path,body)=>{
const response=await fetch(window.Shopify.routes.root+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});
const data=await response.json();if(!response.ok)throw new Error(data.description||'Bitte versuche es erneut.');return data;};
const before=await request('cart.js');
const items=this.active.rows.map(row=>({id:row.variant.id,quantity:1,properties:{'Angebot':this.quantity===4?'2 kaufen + 2 GRATIS':'1 kaufen + 1 GRATIS'}}));
if(!before.items.some(item=>String(item.variant_id)===String(this.gift.id)))items.push({id:this.gift.id,quantity:1});
await request('cart/add.js',{items});added=true;
const codes=[...new Set([...(before.discount_codes||[]).map(c=>c.code),'CAELENEGUIDE100'])];
const cart=await request('cart/update.js',{discount:codes.join(',')});
const gifts=cart.items.filter(item=>String(item.variant_id)===String(this.gift.id));
if(!gifts.length||gifts.some(item=>item.final_line_price!==0))throw new Error('Das Geschenk konnte nicht kostenlos hinzugefügt werden. Bitte prüfe deinen Warenkorb.');
this.status.textContent='Zum Warenkorb …';
window.location.assign(window.Shopify.routes.root+'cart');
}catch(error){this.status.textContent=error.message||'Bitte versuche es erneut.';if(added){const link=document.createElement('a');link.href=window.Shopify.routes.root+'cart';link.className='cb-cart-link';link.textContent='Warenkorb prüfen';this.status.append(' ',link);}}
finally{if(!added){this.busy=false;this.button.removeAttribute('aria-busy');this.refresh();}}
}
});